const DummyIcon = () => <div>No such icon :(</div>;

export default DummyIcon;
